// extracted by mini-css-extract-plugin
module.exports = {"no_data":"NoData_no_data__ox8FA","sm":"NoData_sm__5mh72","md":"NoData_md__1-pwL","lg":"NoData_lg__1mpHK","xlg":"NoData_xlg__1rPka"};